"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sumHelper = sumHelper;
function sumHelper(...args) {
  return args.reduce((sum, num) => sum + (parseInt(num, 10) || 0), 0);
}